/**
 * Messages the page sends to public/sw.js. The worker is a plain script and
 * cannot import this, so the literal is duplicated there — keep them equal.
 */
export const SW_SKIP_WAITING = 'SKIP_WAITING' as const;
